import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Data
import Email from 'services/data/email';

// Components
import Tooltip from 'components/widgets/overlays/tooltip';
import SVG from 'components/widgets/icons/svg';
import DriveFile from 'components/models/files/drive-file';
import EmailMeta from 'components/models/email/emailMeta';

export default class EmailComponent extends React.PureComponent {
  constructor() {
    super();

    this.state = { showLongBody: false };
    this.toggleLongBody = this.toggleLongBody.bind(this);
    this.setHeight = this.setHeight.bind(this);
  }

  toggleLongBody() {
    this.setState({ showLongBody: !this.state.showLongBody });
  }

  setHeight(event) {
    const iframe = event.target;
    const height = iframe.contentDocument.body.scrollHeight + 16;
    iframe.style.height = `${height}px`;
  }

  render() {
    const { email } = this.props;
    const { showLongBody } = this.state;

    return (
      <div className="email-wrapper">
        <h3 className="email-header">{email.subject}</h3>
        <Tooltip className="email-meta-tooltip" title={<EmailMeta email={email} />}>
          <SVG src="svg/email.svg" />
          {Email.getFromShort(email)}
          <SVG src="svg/info.svg" />
        </Tooltip>
        { !showLongBody &&
          <div className="email-body">
            <iframe className="w-100 border-0" scrolling="no" onLoad={this.setHeight} srcDoc={email.sanitizedHtmlBody} />
            <Tooltip className="email-toggle-quoted-text" onClick={this.toggleLongBody} title="Expand quoted text"><SVG src="svg/horizontal-dots.svg" /></Tooltip>
          </div>
        }
        { showLongBody &&
          <div className="email-body">
            <iframe className="w-100 border-0" scrolling="no" onLoad={this.setHeight} srcDoc={email.sanitizedHtmlFullBody} />
            <Tooltip className="email-toggle-quoted-text" onClick={this.toggleLongBody} title="Collapse quoted text"><SVG src="svg/horizontal-dots.svg" /></Tooltip>
          </div>
        }
        { (email.attachments && !!email.attachments.length) &&
          <div className="email-attachments">
            <h5>Attachments</h5>
            <ul className="unstyled-list">
              { _.map(email.attachments, attachment =>
                <DriveFile item={attachment} key={attachment.fileId} />
              )}
            </ul>
          </div>
        }
      </div>
    );
  }
}

EmailComponent.propTypes = {
  email: PropTypes.object
};
